import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                            from '../shared/shared.module';
import { TableModule }                             from '../table/table.module';
import { VehicleRegistrationLookupsComponent }     from './vehicle-registration.lookups.component';
import { VehicleRegistrationPurchaseComponent }    from './vehicle-registration.purchase.component';
import { VehicleRegistrationService }              from './vehicle-registration.service';
import { VehicleRegistrationSettingsComponent }    from './vehicle-registration.settings.component';
import { VehicleRegistrationStatusComponent }      from './vehicle-registration.status.component';
import { VehicleRegistrationTireComponent }        from './vehicle-registration.tire.component';
import { VehicleRegistrationTireDetailsComponent } from './vehicle-registration.tire-details.component';
import { VehicleRegistrationsStates }              from './vehicle-registrations.states';

@NgModule({
  declarations: [
    VehicleRegistrationLookupsComponent,
    VehicleRegistrationPurchaseComponent,
    VehicleRegistrationSettingsComponent,
    VehicleRegistrationStatusComponent,
    VehicleRegistrationTireComponent,
    VehicleRegistrationTireDetailsComponent
  ],
  entryComponents: [
    VehicleRegistrationLookupsComponent,
    VehicleRegistrationPurchaseComponent,
    VehicleRegistrationSettingsComponent,
    VehicleRegistrationStatusComponent,
    VehicleRegistrationTireComponent,
    VehicleRegistrationTireDetailsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: VehicleRegistrationsStates })
  ],
  providers: [
    VehicleRegistrationService
  ]
})
export class VehicleRegistrationsModule {}
